// extracted by mini-css-extract-plugin
export default {"wrapper":"BBBqn9OyjM8p1pd6F4iA","right-margin":"i5M5IytiPWT3TOzL6u8l","container":"fvNcMJ4wK24Cvars4MCg","section":"A7s43M4XdDpz3Q29Gafg","dropdown":"Y4hXoK7EGl925lpW2EuJ"};